import { S3Client, 
  GetObjectCommand, 
  ListObjectsCommand, 
  ListObjectsCommandOutput,
  ListObjectsCommandInput} from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";

export const S3Provider = (() => {
  /*
  const CognitoRegion = "ap-northeast-1"
  const CognitoIdentifyPoolId = "ap-northeast-1:3f8a1b30-fb1d-4877-abef-59ce17bd13bb"
  const S3Region = "ap-northeast-1"
  const S3Bucket = "lscoba-eventgallery-poc-storage-80866e6b140018-staging"
  */
  const CognitoRegion = "ap-northeast-1"
  const CognitoIdentifyPoolId = "ap-northeast-1:b06eaf02-44ac-4868-8e37-14cfcf513c15"
  const S3Region = "ap-northeast-1"
  const S3Bucket = "lscoba-eventgallery"
  const S3BucketPublic = true

  const listObjectsInFolder = async (folder: string) => {
    const client = new S3Client({
      region: S3Region,
      credentials: fromCognitoIdentityPool({
        clientConfig: { region: CognitoRegion },
        identityPoolId: CognitoIdentifyPoolId
      }),
    })
    const params : ListObjectsCommandInput = { 
      Bucket: S3Bucket,
      Prefix: folder,
      Delimiter: folder
    }
    const allKeys : string[] = []
    await recursive()
    return allKeys
      .filter(e => e.length > folder.length)
      .filter(e => !(e.split("/").reverse()[0].startsWith("thumbnail_")))
      .sort()
    
    async function recursive() {
      var res: (ListObjectsCommandOutput | void) = await client.send(new ListObjectsCommand(params)).catch(console.error)
      if (!(res instanceof Object) || res == undefined || res.Contents == undefined) { return }
      res.Contents.forEach(e => {if (e.Key != undefined) allKeys.push(e.Key)})
      if (res.IsTruncated) {
        params.Marker = res.NextMarker
        await recursive()
      }
    }
  }

  const listFolders = async () => {
    const client = new S3Client({
      region: S3Region,
      credentials: fromCognitoIdentityPool({
        clientConfig: { region: CognitoRegion },
        identityPoolId: CognitoIdentifyPoolId
      }),
    })
    const command = new ListObjectsCommand({ 
      Bucket: S3Bucket,
      Delimiter: "/"
    })
    var res: (ListObjectsCommandOutput | void) = await client.send(command)
    if (!(res instanceof Object) || res == undefined || res.CommonPrefixes == undefined) { return [] }
    return res.CommonPrefixes
      .flatMap(e => e ? (e.Prefix ? [e.Prefix] : []) : [])
      .sort()
  }

  const getObjSrc = (path: string) => {
    if (S3BucketPublic) {
      return `https://${S3Bucket}.s3.${S3Region}.amazonaws.com/${path}`
    }
    return ""
  }

  const getObjThumbnailSrc = (path: string) => {
    var split = path.split("/")
    split[split.length - 1] = `thumbnail_${split[split.length - 1]}`
    path = split.join("/")
    
    if (S3BucketPublic) {
      return `https://${S3Bucket}.s3.${S3Region}.amazonaws.com/${path}`
    }
    return ""
  }

  return {
    listFolders,
    listObjectsInFolder,
    getObjSrc,
    getObjThumbnailSrc
  };
})()